export const NETWORK_MOBILE_CONNECTED = 'NETWORK_MOBILE_CONNECTED';
export const NETWORK_MOBILE_DISCONNECTED = 'NETWORK_MOBILE_DISCONNECTED';
